// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1tOX7","form":"styles_form__Y3HdU"};